import type { createListenerMiddleware } from '@reduxjs/toolkit';
import type { ModalConfigIdType } from 'BreetConfig';
import { isBusinessOwner, isSandboxEnvironment } from 'BreetHelpers';

import { setUserData } from '../slices/app/appSlice';
import { closeModal, openModal } from '../slices/app/modalSlice';
import type { AppDispatch, RootState } from '../store';

const KYB_GUARDED_MODALS = new Set<ModalConfigIdType>(['rateCalculator', 'cryptoSettings']);

const isKybPending = (state: RootState): boolean => {
	const { targetEnvironment, isApprovedForLive, userData } = state.app;
	if (isSandboxEnvironment(targetEnvironment)) return false;
	if (isApprovedForLive) return false;
	if (!userData || userData.approvedForLive) return false;
	return isBusinessOwner(userData);
};

const sendToOnboarding = (api: { dispatch: AppDispatch }, modalId: ModalConfigIdType) => {
	api.dispatch(closeModal(modalId));
	api.dispatch(openModal({ id: 'onBoardingTodoList', wrapperClassName: 'onboarding-todolist-wrapper' }));
};

export function modalGuardListeners(mw: ReturnType<typeof createListenerMiddleware>) {
	const startListening = mw.startListening.withTypes<RootState, AppDispatch>();

	// Guard at open time.
	startListening({
		actionCreator: openModal,
		effect: (action, api) => {
			if (!KYB_GUARDED_MODALS.has(action.payload.id) || !isKybPending(api.getState())) return;

			sendToOnboarding(api, action.payload.id);
		},
	});

	startListening({
		actionCreator: setUserData,
		effect: (_, api) => {
			if (!isKybPending(api.getState())) return;

			const openGuarded = api.getState().modals.find((modal) => KYB_GUARDED_MODALS.has(modal.id));
			if (openGuarded) sendToOnboarding(api, openGuarded.id);
		},
	});
}
